var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-cards',{ref:"dashboardCards",attrs:{"useLocalPanels":"","extraParams":_vm.extraParams,"localPanels":_vm.localPanels}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }